module.exports = __webpack_public_path__ + "img/detail-banner.92a724d7.jpg";